import { useState } from "react";
import api from "../../services/api";
import AppLayout from "../layout/AppLayout";

export default function CadastrarCliente() {
  const [form, setForm] = useState({ nome: "", email: "", cpf: "", telefone: "" });
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onChange = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  async function onSubmit(e) {
    e.preventDefault();
    setMsg(""); setErr(""); setLoading(true);
    try {
      await api.post("/admin_create_client.php", form);
      setMsg("Cliente cadastrado! Link para definir senha enviado por email.");
      setForm({ nome: "", email: "", cpf: "", telefone: "" });
    } catch {
      setErr("Não foi possível cadastrar. Verifique email e tente novamente.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AppLayout title="Cadastrar Cliente" subtitle="Cria acesso do cliente com segurança" role="admin">
      <form onSubmit={onSubmit} className="max-w-xl rounded-2xl border border-[#1f2937] bg-[#121826] p-6 space-y-4">
        {msg && <div className="text-sm text-green-400">{msg}</div>}
        {err && <div className="text-sm text-red-400">{err}</div>}

        <input className="w-full rounded-xl border border-[#1f2937] bg-[#0b0f19] px-4 py-3"
          placeholder="Nome" value={form.nome} onChange={onChange("nome")} required />

        <input className="w-full rounded-xl border border-[#1f2937] bg-[#0b0f19] px-4 py-3"
          placeholder="Email" type="email" value={form.email} onChange={onChange("email")} required />

        <div className="grid gap-4 md:grid-cols-2">
          <input className="w-full rounded-xl border border-[#1f2937] bg-[#0b0f19] px-4 py-3"
            placeholder="CPF (opcional)" value={form.cpf} onChange={onChange("cpf")} />
          <input className="w-full rounded-xl border border-[#1f2937] bg-[#0b0f19] px-4 py-3"
            placeholder="Telefone (opcional)" value={form.telefone} onChange={onChange("telefone")} />
        </div>

        <button disabled={loading}
          className="w-full rounded-xl bg-blue-600 py-3 text-sm font-semibold hover:bg-blue-500 disabled:opacity-60">
          {loading ? "Salvando..." : "Cadastrar"}
        </button>
      </form>
    </AppLayout>
  );
}
